import type { ColumnDef } from "@tanstack/react-table";
import type { ApVendor } from "@/accounts-payable/types";
import {
  QUICKBOOKS_BUSINESS_DEFAULT,
  QUICKBOOKS_EXPENSE_ACCOUNT_LABEL,
} from "@/accounts-payable/vendors-tab/quickbooks-labels";
import { quickbooksAccountLabel } from "@/business/quickbooks-utils";

// A vendor's own account override; without one the business default applies.
export const expenseAccountCol: ColumnDef<ApVendor> = {
  id: "quickbooks_expense_account",
  header: QUICKBOOKS_EXPENSE_ACCOUNT_LABEL,
  accessorFn: (row) =>
    row.quickbooks_expense_account
      ? quickbooksAccountLabel(row.quickbooks_expense_account)
      : "",
  meta: { size: "220px" },
  cell: ({ row }) =>
    row.original.quickbooks_expense_account ? (
      <span className="block truncate">
        {quickbooksAccountLabel(row.original.quickbooks_expense_account)}
      </span>
    ) : (
      <span className="text-subtle">{QUICKBOOKS_BUSINESS_DEFAULT}</span>
    ),
};
